module.exports = __webpack_public_path__ + "img/logo_katsuwin.6713d75f.png";